import { IconeProprio, type PropsIcone } from './base'

/**
 * Ícone próprio de table top de ocorrência (simulador tático de cena 3D).
 *
 * Representa a maquete tática em vista superior: delimitação de perímetro
 * da mesa/cena por cantoneiras, veículo sinistrado no centro e cones de
 * sinalização e balizamento da zona de intervenção.
 */
export function IconeTabletop(props: PropsIcone) {
  return (
    <IconeProprio {...props}>
      {/* Cantoneiras de enquadramento do perímetro da mesa/cenário */}
      <path d="M2.5 6.5V3.5h3" />
      <path d="M18.5 3.5h3v3" />
      <path d="M2.5 17.5v3h3" />
      <path d="M18.5 20.5h3v-3" />
      {/* Veículo posicionado no cenário (vista superior com para-brisas e teto) */}
      <rect x="8.5" y="5.5" width="7" height="13" rx="2" />
      <path d="M9.5 9c1.2 1 3.8 1 5 0" />
      <path d="M9.5 15.5c1.2-.8 3.8-.8 5 0" />
      <path d="M12 10.5v3.5" />
      {/* Cone de sinalização superior (perímetro de segurança) */}
      <path d="M3 11h4" />
      <path d="M3.5 11l1.5-4 1.5 4" />
      <path d="M4.2 9.5h1.6" />
      {/* Cone de sinalização inferior (balizamento da zona quente) */}
      <path d="M3 18.5h4" />
      <path d="M3.5 18.5l1.5-4 1.5 4" />
      <path d="M4.2 17h1.6" />
    </IconeProprio>
  )
}

/** Compatibilidade com o registro de módulos. */
export const IconeModuloTabletop = IconeTabletop
